module.exports = __webpack_public_path__ + "img/car_5.e27e3ab7.png";